module.exports = __webpack_public_path__ + "img/title-@2x.7fc1ae8f.png";